module.exports = __webpack_public_path__ + "img/category_romance.4c454b7.png";